// extracted by mini-css-extract-plugin
export default {"icon_container":"styles_icon_container__wPZsP","icon_wrapper":"styles_icon_wrapper__G54DT"};